import ImportStatus from "@mapmycustomers/shared/enum/imports/ImportStatus";
import Import from "@mapmycustomers/shared/types/imports/Import";

import ImportHistoryRow from "@app/scene/settings/component/Imports/type/ImportHistoryRow";
import convertToHistoryRow from "@app/scene/settings/component/Imports/util/convertToHistoryRow";

const doesImportHaveSkipFile = (importRecord?: Import) => {
  if (!importRecord) {
    return false;
  }
  const { errorsCount, status, warningsCount }: ImportHistoryRow =
    convertToHistoryRow(importRecord);
  return status === ImportStatus.COMPLETED && errorsCount + warningsCount > 0;
};

export default doesImportHaveSkipFile;
